import { useTranslation } from "react-i18next";

function MaintenancePage() {
    const { t } = useTranslation();
    return (
        <div className="min-h-screen flex items-center justify-center bg-fpcwhite px-4">
            <div className="bg-white rounded-xl p-8 shadow-2xl max-w-md w-full text-center">
                <a href="/" className="inline-block mb-6">
                    <img src="/logoFPC192.png" alt="FPC" className="h-12 w-auto mx-auto" />
                </a>
                <h1 className="text-3xl font-extrabold text-fpcred mb-4">{t("maintenanceTitle")}</h1>
                <p className="text-base text-grey1">{t("maintenanceDescription")}</p>
            </div>
        </div>
    )
}

export default MaintenancePage
